import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { Link } from 'react-router-dom';
import { asset } from 'Services/BaseHelpers';
import GettingReady from "Pages/MainStage/GettingReady";

export default class Dashboard extends React.Component {
    render() {
        return (
            <Authenticated pageTitle="Dashboard" noContainer>
                <div className="w-full bg-app-blue text-app-gold2 -mt-4 p-8">
                    <div className="max-w-5xl mx-auto flex flex-col-reverse lg:flex-row">
                        <div className="w-full md:w-2/3 m-auto text-lg text-center">
                            <div className="font-aleo text-4xl w-[75%] lg:w-[60%] mx-auto mb-3">
                                Welcome to the Taylor & Francis Awards 2021
                            </div>

                            <div className="font-open-sans font-light text-lg w-[80%] lg:w-[70%] mx-auto mb-3">
                                Thursday 7 April 2022
                            </div>

                            <div className="font-open-sans font-light text-lg w-[80%] lg:w-[70%] mx-auto">
                                8.00am Boca, Philadelphia, New York | 1.00pm London | 5.30pm Bengaluru, Delhi | 8.00pm Singapore, Beijing | 10.00pm Australia
                            </div>
                        </div>

                        <div className="w-2/3 lg:w-1/3 mx-auto pt-4 pb-8 lg:pb-4">
                            <img alt="" className="mx-auto" src={asset('/images/awards.png')} />
                        </div>
                    </div>
                </div>

                <div className="bg-primary bg-cover flex-1 flex flex-col">
                    <div className="max-w-5xl mx-auto space-y-6 px-4 py-8 my-auto text-center">
                        <div>
                            Each year the T&F Awards are our opportunity to recognise and celebrate the people, projects and successes that make Taylor & Francis so unique.
                        </div>

                        <div>
                            Join in the celebrations from wherever you are in the world.
                        </div>

                        <Link
                            to="/main-stage"
                            className="bg-app-blue-light text-white py-3 rounded-md mx-auto w-1/2 block"
                        >
                            Watch live show here
                        </Link>
                    </div>
                </div>

                <GettingReady />
            </Authenticated>
        );
    }
}
